/**
 * Kit de Atendimento polling rules
 *
 * When an appointment is just created, the documents (Guia/ASO/Ficha) are
 * generated asynchronously in the backend and can take a few seconds to
 * become available. The Kit page polls `GET /public/kit/:token` while any
 * document is still pending, up to a bounded number of attempts, so an old
 * appointment whose PDF generation permanently failed doesn't poll forever.
 */

export const KIT_POLL_INTERVAL_MS = 2500;
export const KIT_POLL_MAX_ATTEMPTS = 12; // ~30s, folgado para uma geração de ~5s

export function shouldKeepPolling(
  documents: Array<{ available: boolean }>,
  attempt: number,
): boolean {
  if (attempt >= KIT_POLL_MAX_ATTEMPTS) return false;
  return documents.some(doc => !doc.available);
}

/**
 * Whether a failed polling attempt (e.g. a network blip) should be retried.
 * Shares the same attempt budget as `shouldKeepPolling` so a run of network
 * errors doesn't get a different retry window than a run of "still pending"
 * responses — both give up at the same attempt count.
 */
export function canRetryAfterError(attempt: number): boolean {
  return attempt < KIT_POLL_MAX_ATTEMPTS;
}
